const removeAllIndentations = (draggableCodeLine) => {
  let result = draggableCodeLine;
  /*while (result?.content?.length && result?.content[0] === ' ') {
    result = {...result, content: result.content.slice(1)}
  }*/
  return result;
};

export default removeAllIndentations;